import {
  ArrowDownTrayIcon,
  ArrowPathIcon,
  ArrowsRightLeftIcon,
  ArrowTopRightOnSquareIcon,
  ArrowUpTrayIcon,
  BookOpenIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ClockIcon,
  DocumentCheckIcon,
  DocumentPlusIcon,
  DocumentTextIcon,
  EyeIcon,
  FolderPlusIcon,
  LinkIcon,
  MegaphoneIcon,
  PencilIcon,
  PencilSquareIcon,
  PlusIcon,
  TrashIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { ButtonIcon } from './Button';

/**
 * One icon per semantic action, for the whole app.
 *
 * The point is not to save an import — it is that "add report" was previously a plus in the
 * reports timeline, a bare label in the case cockpit and a generic document tile on the
 * dashboard. Naming the action instead of the glyph makes divergence impossible to introduce
 * by accident, and lets a glyph be swapped everywhere from one line.
 */
export const actionIcon = {
  add: PlusIcon,
  addReport: DocumentPlusIcon,
  viewReports: DocumentTextIcon,
  monthlyReport: ChartBarIcon,
  addNote: PencilIcon,
  schedule: CalendarDaysIcon,
  event: MegaphoneIcon,
  view: EyeIcon,
  deepen: BookOpenIcon,
  edit: PencilSquareIcon,
  delete: TrashIcon,
  timeline: ClockIcon,
  reassign: ArrowsRightLeftIcon,
  closeCase: DocumentCheckIcon,
  download: ArrowDownTrayIcon,
  upload: ArrowUpTrayIcon,
  replace: ArrowPathIcon,
  addFolder: FolderPlusIcon,
  addLink: LinkIcon,
  externalLink: ArrowTopRightOnSquareIcon,
  close: XMarkIcon,
} satisfies Record<string, ButtonIcon>;

export type ActionName = keyof typeof actionIcon;
